import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-links">
        <Link to="/" className="footer-link">Home</Link>
        <Link to="/about" className="footer-link">About</Link>
        <a href="https://github.com" className="footer-link" target="_blank" rel="noopener noreferrer">GitHub</a>
        <Link to="/contact" className="footer-link">Contact</Link>
      </div>
      <p>&copy; 2025 JustDoCode. Learn programming with fun! 🎮⚽🏏</p>
    </footer>
  );
};

export default Footer;

